import React, {useEffect, useState} from 'react';
import gsap from 'gsap';
import renderHTML from 'react-render-html';
import './Scorecard.sass';
import ThumbsUp from './../../../../icons/thumb_up.svg';
import ThumbsDown from './../../../../icons/thumb_down.svg';

const Scorecard = React.forwardRef(({model, toggle, reset, advance}, ref) => {

        const [selectedIndex, setSelectedIndex] = useState(-1);
        const [feedback, setFeedback] = useState(null)

        const {instructions} = model;

        useEffect(() => {
            console.log("useEffect feedback");
            if (feedback) {
                console.log("fb.title " + feedback.title)
                console.log("selectedIndex: " + selectedIndex)
            }

        }, [feedback]);

        const handleSelection = (index) => {
            setSelectedIndex(index);
            var fb = (index>-1)?(model.passed(model.getFieldByIndex(index).id) ? model.getFieldByIndex(index).feedback.passed : model.getFieldByIndex(index).feedback.failed):null;
            setFeedback(fb);
        }

        const doReset = () => {
            model.reset();
            reset();
        }


        return (
            <div className="scorecard"
                 ref={ref}>
                <div className="scorecard-container">
                    <div className="scorecard-row">
                        <div className="scorecard-panel">
                            <span className="title" onClick={()=>{handleSelection(-1)}}>Scorecard</span>
                            {
                                model ? model.getFields().map((f, index) => (
                                    <div key={index}
                                         onClick={() => (handleSelection(index))}
                                         className={(index === selectedIndex) ? "score-item selected" : "score-item"}>
                                        {f.label}
                                        {model.passed(f.id) ?
                                            <img className="thumb-icon"
                                                 src={ThumbsUp}/> :
                                            <img className="thumb-icon"
                                                 src={ThumbsDown}/>
                                        }
                                    </div>
                                )) : null
                            }
                        </div>
                        <div className="feedback-panel">
                            <div className={"feedback-title "+ (feedback?(model.passed(model.getFieldByIndex(selectedIndex).id)?"passed":"failed"):"default")}>
                                {feedback ? feedback.title : model.instructions.title}
                            </div>
                            <div className="feedback-body">
                                {renderHTML(feedback ? feedback.body : model.instructions.body)}
                            </div>
                        </div>
                    </div>
                    <div className="button-row">
                    {
                        model.passed()?
                            <div className="scorecard-button"
                                 onClick={advance}>
                                Done
                            </div>:<div className="scorecard-button"
                                        onClick={doReset}>
                                Try Again
                            </div>

                    }

                    </div>
                </div>
            </div>
        );

    }
);


export default Scorecard;
